import { IMAGE_CACHE_RESOLVE } from '@synergy/config';
import urlJoin from 'url-join';

export const getDynamicImageCachePath = (apiBaseUrl: string, cachePath: string, path: string) => {
    // eslint-disable-next-line no-console
    console.warn('getDynamicImageCachePath is used, please add the image cache path to the settings');
    return urlJoin(apiBaseUrl, IMAGE_CACHE_RESOLVE, cachePath, path, 'dynamic=true');
};
